import React from 'react';

import { BadgeDetailHeader, MintRecords } from '../../components';
import style from './index.module.scss';

export default ({ id }: { id: string }) => {
  return (
    <div className={style.container}>
      <BadgeDetailHeader id={id} />
      <MintRecords id={id} className={style.records} />
    </div>
  );
};
